import script from "./TheQrCode.vue?vue&type=script&setup=true&lang=js"
export * from "./TheQrCode.vue?vue&type=script&setup=true&lang=js"

import "./TheQrCode.vue?vue&type=style&index=0&id=2d7cba98&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d7cba98"]])

export default __exports__